module.exports = __webpack_public_path__ + "static/media/photo177.d3a1bd58.jpg";